import Vue from "vue";

import {last} from 'lodash'


export interface IRegion {
    areaCode: string
    regionCode: string
    regionName: string
}



export const getAreaLocaleTitleByCode = (code:string):string|undefined => { //大区映射
    return ({
        "cn": Vue.$trans(`国内`), //"国内",
        "ap": Vue.$trans(`亚太`), //'亚太',
        "eu": Vue.$trans(`欧洲`), //'欧洲'
    } as any)[code];
}

export const getAzLocaleTitleByCode = (code:string):string => {
    let lastCode = last(code) || '';
    // 这里还是列出所有可用区，便于后续接入新版国际化系统（新版国际化系统trans函数不能接收变量）
    return ({
        a: Vue.$trans(`可用区A`),
        b: Vue.$trans(`可用区B`),
        c: Vue.$trans(`可用区C`),
        d: Vue.$trans(`可用区D`),
        e: Vue.$trans(`可用区E`),
    } as any)[lastCode] || ''
}

export const getRegionLocaleTitleByCode = (code:string):string => {
    return ({
        //测试环境机房
        "cn-qingyangtest-1": Vue.$trans(`庆阳1区（测试）`), //庆阳1区（测试）
        // "cn-qingdaodev-1": Vue.$trans(`自用（青岛2）`), //自用(青岛2) 原：青岛研发1区(VPC)
        // "cn-shanghai-3": Vue.$trans(`华东2（上海）`), //华东2(上海) 原：上海3区(VPC)
        // "cn-shanghai-7": Vue.$trans(`上海3区（Basic）`), //上海3区(Basic)

        //线上环境机房
        "cn-beijing-6": Vue.$trans(`华北1（北京）`), //华北1(北京) 原：北京6区(VPC)
        "cn-beijing-fin": Vue.$trans(`华北金融1（北京）`), //华北金融1(北京) 原：北京金融（万国)
        "cn-north-1-gov": Vue.$trans(`华北政务1（北京）`), //华北政务1(北京) 原：华北1(政务)
        "cn-shanghai-2": Vue.$trans(`华东1（上海）`), //华东1(上海) 原：上海2区(VPC)
        "cn-shanghai-fin": Vue.$trans(`华东金融1（上海）`), //华东金融1(上海) 原：上海金融（鹏博士)
        "cn-guangzhou-1": Vue.$trans(`华南1（广州）`), //华南1(广州) 原：广州1区(VPC)
        "cn-hongkong-2": Vue.$trans(`香港`), //香港 原：香港2区(VPC)
        "cn-taipei-1": Vue.$trans(`台北`), //台北 原：台北1区(VPC)
        "cn-qingdao-1": Vue.$trans(`自用（青岛）`), //自用(青岛) 原：青岛1区(VPC)
        "ap-singapore-1": Vue.$trans(`新加坡`), //新加坡 原：新加坡机房
        "eu-east-1": Vue.$trans(`俄罗斯（莫斯科）`), //俄罗斯(莫斯科) 原：俄罗斯1区(VPC)
        "cn-northwest-1": Vue.$trans(`西北1区（庆阳）`),
        "cn-northwest-2": Vue.$trans(`西北2区（自用）`),
        "cn-north-vip1": Vue.$trans(`华北专属1区（天津-小米）`),
        "cn-northwest-3": Vue.$trans('西北3区（宁夏）'),

        //主机控制台暂未启用
        "cn-central-1": Vue.$trans(`华中1（武汉）`), //华中1(武汉) 原：华中1
        "cn-southwest-1": Vue.$trans(`西南1（重庆）`), //西南1(重庆) 原：西南1
        "ap-Indonesia-1": Vue.$trans(`印度尼西亚（雅加达）`), //印度尼西亚(雅加达) 原：印尼1(VPC)
    } as any)[code] || code
}
